import React from "react";
import Footer from "../components/Shared/Footer";
import ArticleView from "../components/Article_Display_Page/ArticleView";
import Breadcrumbs from "../components/Article_Display_Page/Breadcrumbs";
import Navbar from "../components/NavBar/Navbar";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "../hooks/useTranslation";


const TermsAndConditions = () => {
  const theme = useTheme();
  const { t, language } = useTranslation();
  
  const getTermsContent = () => {
    if (language === 'pl') {
      return `
        <p><i>Ostatnia aktualizacja: 5 lutego 2026</i></p>

        <p>Prosimy o uważne przeczytanie niniejszych Warunków przed skorzystaniem z Usługi.</p>

        <h2>Interpretacja i Definicje</h2>
        <h3>Interpretacja</h3>
        <p>Słowa, których pierwsza litera jest pisana wielką literą, mają znaczenie zdefiniowane w niniejszych Warunkach. Definicje mają takie samo znaczenie niezależnie od liczby pojedynczej lub mnogiej.</p>

        <h3>Definicje</h3>
        <ul>
          <li><p><strong>Firma</strong> oznacza Żak Artur – Usługi gastronomiczne (NIP: 7361585770, REGON: 120573125). Adres rejestrowy: ul. Środkowa 242A, 34-405 Białka Tatrzańska. Dane kontaktowe: ul. Środkowa 242A, 34-405 Bukowina Tatrzańska.</p></li>
          <li><p><strong>Kraj</strong> oznacza Polskę.</p></li>
          <li><p><strong>Usługa</strong> oznacza stronę internetową umożliwiającą składanie zamówień online.</p></li>
          <li><p><strong>Strona internetowa</strong> oznacza Zielona Chatka, dostępną pod adresem <a href="${process.env.REACT_APP_CLIENT_URL}" target="_blank" rel="noopener noreferrer">${process.env.REACT_APP_CLIENT_URL}</a>.</p></li>
          <li><p><strong>Użytkownik / Ty</strong> oznacza osobę korzystającą z Usługi.</p></li>
          <li><p><strong>Zamówienie</strong> oznacza zamówienie produktów spożywczych lub napojów złożone za pośrednictwem Usługi.</p></li>
        </ul>

        <h2>Akceptacja Warunków</h2>
        <p>Korzystając z Usługi lub składając Zamówienie, potwierdzasz, że zapoznałeś się z niniejszymi Warunkami i zgadzasz się być nimi związany.</p>
        <p>Jeżeli nie zgadzasz się z jakąkolwiek częścią Warunków, nie korzystaj z Usługi.</p>
        <p>Usługa przeznaczona jest wyłącznie dla osób, które ukończyły 18 lat.</p>

        <h2>Składanie Zamówień</h2>
        <p>Usługa umożliwia składanie zamówień na produkty oferowane przez Firmę z odbiorem osobistym w lokalu.</p>
        <p>Złożenie Zamówienia oznacza zawarcie umowy sprzedaży pomiędzy Tobą a Firmą.</p>
        <p>Zamówienie uznaje się za przyjęte w momencie potwierdzenia jego realizacji przez system.</p>

        <h2>Płatności</h2>
        <p>Płatności za Zamówienia realizowane są online za pośrednictwem zewnętrznego operatora płatności (Stripe).</p>
        <p>Firma nie przechowuje danych kart płatniczych.</p>
        <p>Wszystkie ceny podane są w obowiązującej walucie i zawierają należne podatki, o ile nie wskazano inaczej.</p>

        <h2>Realizacja Zamówień</h2>
        <p>Czas przygotowania Zamówienia jest orientacyjny i może ulec zmianie w zależności od obciążenia lokalu.</p>
        <p>Firma nie gwarantuje dokładnego czasu realizacji Zamówienia.</p>
        <p>Odpowiedzialność Firmy za Zamówienie kończy się w momencie wydania produktu Użytkownikowi.</p>

        <h2>SMS i powiadomienia</h2>
        <p>Podając numer telefonu, wyrażasz zgodę na otrzymywanie wiadomości SMS związanych wyłącznie z realizacją Zamówienia (np. potwierdzenie, informacja „zamówienie gotowe”).</p>
        <p>SMS mają charakter informacyjny. Firma nie ponosi odpowiedzialności za opóźnienia lub brak dostarczenia wiadomości spowodowane przez operatora telekomunikacyjnego lub dostawcę usługi SMS.</p>

        <h2>Brak prawa odstąpienia od umowy</h2>
        <p>Zgodnie z art. 38 pkt 4 ustawy o prawach konsumenta, Użytkownikowi nie przysługuje prawo odstąpienia od umowy po rozpoczęciu przygotowywania Zamówienia, ponieważ przedmiotem umowy są produkty szybko psujące się lub przygotowywane na indywidualne zamówienie.</p>

        <h2>Alergeny i odpowiedzialność żywieniowa</h2>
        <p>Firma dokłada starań, aby informować o alergenach zgodnie z obowiązującymi przepisami.</p>
        <p>Użytkownik ponosi odpowiedzialność za sprawdzenie składu produktów przed złożeniem Zamówienia.</p>

        <h2>Ograniczenie odpowiedzialności</h2>
        <p>Firma nie ponosi odpowiedzialności za:</p>
        <ul>
          <li>przerwy w działaniu Usługi wynikające z przyczyn technicznych,</li>
          <li>działania podmiotów trzecich (np. operatorów płatności, SMS, sieci Internet),</li>
          <li>szkody pośrednie lub wtórne, w najszerszym zakresie dozwolonym przez prawo.</li>
        </ul>

        <h2>Linki do stron trzecich</h2>
        <p>Usługa może zawierać linki do stron trzecich. Firma nie ponosi odpowiedzialności za ich treść ani polityki prywatności.</p>

        <h2>Prawo właściwe i jurysdykcja</h2>
        <p>Niniejsze Warunki podlegają prawu polskiemu.</p>
        <p>Wszelkie spory będą rozstrzygane przez właściwe sądy Rzeczypospolitej Polskiej.</p>

        <h2>Zmiany Warunków</h2>
        <p>Firma zastrzega sobie prawo do zmiany Warunków. Zmiany wchodzą w życie z chwilą ich opublikowania na Stronie internetowej.</p>
        <p>Kontynuowanie korzystania z Usługi po wprowadzeniu zmian oznacza ich akceptację.</p>

        <h2>Kontakt</h2>
        <p>W przypadku pytań dotyczących Warunków prosimy o kontakt:</p>
        <ul>
          <li>Pocztą: Żak Artur – Usługi gastronomiczne, ul. Środkowa 242A, 34-405 Bukowina Tatrzańska</li>
          <li>E-mail: contact@zielonachatka.com</li>
        </ul>
      `;
    }
    
    // English (default)
    return `
      <p><i>Last updated: February 5, 2026</i></p>
      <p>Please read these Terms carefully before using the Service.</p>

      <h2>Interpretation and Definitions</h2>
      <h3>Interpretation</h3>
      <p>Words with an initial capital letter have meanings defined in these Terms. Definitions have the same meaning regardless of whether they appear in singular or plural form.</p>

      <h3>Definitions</h3>
      <ul>
        <li><p><strong>Company</strong> means Żak Artur – Usługi gastronomiczne (NIP: 7361585770, REGON: 120573125). Registered address: ul. Środkowa 242A, 34-405 Białka Tatrzańska, Poland. Contact address: ul. Środkowa 242A, 34-405 Bukowina Tatrzańska, Poland.</p></li>
        <li><p><strong>Country</strong> means Poland.</p></li>
        <li><p><strong>Service</strong> means the website that enables placing online orders.</p></li>
        <li><p><strong>Website</strong> means Zielona Chatka, accessible at <a href="${process.env.REACT_APP_CLIENT_URL}" target="_blank" rel="noopener noreferrer">${process.env.REACT_APP_CLIENT_URL}</a>.</p></li>
        <li><p><strong>User / You</strong> means the person using the Service.</p></li>
        <li><p><strong>Order</strong> means an order for food or beverages placed through the Service.</p></li>
      </ul>

      <h2>Acceptance of the Terms</h2>
      <p>By using the Service or placing an Order, you confirm that you have read these Terms and agree to be bound by them.</p>
      <p>If you do not agree with any part of the Terms, do not use the Service.</p>
      <p>The Service is intended exclusively for persons who are at least 18 years old.</p>

      <h2>Placing Orders</h2>
      <p>The Service allows you to place orders for products offered by the Company for in-person pickup at the premises.</p>
      <p>Placing an Order constitutes entering into a sales contract between you and the Company.</p>
      <p>An Order is considered accepted at the moment its fulfillment is confirmed by the system.</p>

      <h2>Payments</h2>
      <p>Payments for Orders are processed online through an external payment operator (Stripe).</p>
      <p>The Company does not store payment card details.</p>
      <p>All prices are shown in the applicable currency and include all required taxes, unless stated otherwise.</p>

      <h2>Order Fulfillment</h2>
      <p>Order preparation times are estimates and may change depending on the workload of the premises.</p>
      <p>The Company does not guarantee an exact order completion time.</p>
      <p>The Company’s responsibility for an Order ends at the moment the product is handed over to the User.</p>

      <h2>SMS and Notifications</h2>
      <p>By providing a phone number, you consent to receiving SMS messages solely related to the fulfillment of your Order (e.g., confirmation, “order ready” notification).</p>
      <p>SMS messages are informational only. The Company is not responsible for delays or non-delivery caused by telecommunications operators or SMS service providers.</p>

      <h2>No Right of Withdrawal</h2>
      <p>Pursuant to Article 38(4) of the Polish Consumer Rights Act, the User is not entitled to withdraw from the contract once the preparation of the Order has begun, as the subject of the contract consists of perishable goods or items prepared to the User’s individual request.</p>

      <h2>Allergens and Food Responsibility</h2>
      <p>The Company makes reasonable efforts to provide allergen information in accordance with applicable regulations.</p>
      <p>The User is responsible for reviewing product ingredients before placing an Order.</p>

      <h2>Limitation of Liability</h2>
      <p>The Company shall not be liable for:</p>
      <ul>
        <li>interruptions in the operation of the Service due to technical reasons,</li>
        <li>actions or omissions of third parties (e.g., payment processors, SMS providers, Internet networks),</li>
        <li>indirect or consequential damages, to the fullest extent permitted by law.</li>
      </ul>

      <h2>Third-Party Links</h2>
      <p>The Service may contain links to third-party websites. The Company is not responsible for their content or privacy policies.</p>

      <h2>Governing Law and Jurisdiction</h2>
      <p>These Terms are governed by the laws of Poland.</p>
      <p>Any disputes shall be resolved by the competent courts of the Republic of Poland.</p>

      <h2>Changes to the Terms</h2>
      <p>The Company reserves the right to amend these Terms. Changes take effect upon publication on the Website.</p>
      <p>Continued use of the Service after changes are introduced constitutes acceptance of the amended Terms.</p>

      <h2>Contact</h2>
      <p>If you have any questions regarding these Terms, please contact us:</p>
      <ul>
        <li>By mail: Kotelnica nr II, 34-405 Białka Tatrzańska</li>
        <li>Email: contact@zielonachatka.com</li>
      </ul>
    `;
  };
  
  const blogArticleDetails = {
    blogTitle: t('termsAndConditions'),
    blogAuthor: "Zielona Chatka",
    blogContent: getTermsContent()
  };
  
  return (
    <div style={{backgroundColor: theme.palette.common.background}}>
      <Navbar />
      <Breadcrumbs title="termsAndConditions" />
      <ArticleView blogArticleDetails={blogArticleDetails} />
      <Footer />
    </div>
  );
};

export default TermsAndConditions;